import {Component, OnInit} from '@angular/core';
import {TutorService} from './tutor.service';
import {FormBuilder, FormControl, FormGroup, FormGroupDirective, NgForm} from '@angular/forms';
import {ErrorStateMatcher} from '@angular/material/core';

export class FormErrorStateMatcher implements ErrorStateMatcher {
  isErrorState (control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}

@Component({
  selector: 'app-tutor',
  templateUrl: './tutor.component.html',
  styleUrls: [ './tutor.component.scss' ]
})
export class TutorComponent implements OnInit {

  public searchForm: FormGroup;
  public numDoc: string;
  public callResult: any = {};
  public spinner: boolean = false;

  public errorMessage: string;
  public cpf: string;
  public member: string;
  public category: string;
  public situation: string;
 public matcher = new FormErrorStateMatcher();
 
  constructor (
    private _formBuilder: FormBuilder,
    private _tutorService: TutorService,
  ) {

    this.searchForm = this._formBuilder.group({
      cpf: new FormControl(this.numDoc)
    });
  }

  ngOnInit () {
  }

  tutorGetMemberSituation () {
    this.spinner = true
    this.errorMessage = "";
    this.cpf = "";
    this.member = "";
    this.category = "";
    this.situation = "";

    if (this.searchForm.valid) {
      const doc = this.searchForm.controls.cpf.value
      this._tutorService.tutorGetMemberSituation(doc)
        .subscribe((result) => {
          console.log("result: " + JSON.stringify(result))

          if (result.hasError){
            this.errorMessage = result.error;
          } else {
            this.cpf = result.data.cpf;
            this.member = result.data.member;
            this.category = result.data.category;
            this.situation = result.data.situation;

          }
          this.spinner = false;
        });
    }
  }

}
